import { QUERY_KEYS } from "library/shared";
import { useQuery, UseQueryResult } from "react-query";
import api from "service/api";

/**
 * The endpoint returns a list of document links. The client app only ever
 * receives one element - the user manual.
 */
const getUserManualLinks = async (): Promise<string[]> => {
  // A 403 here means this user has no document to open - it must not redirect
  // the whole app to the unauthorized page.
  const response = await api.get(`/usermanuallink`, {
    skipUnauthorizedRedirect: true,
  });
  const data = response.data;

  if (Array.isArray(data)) {
    return data.filter((link) => typeof link === "string" && !!link);
  }

  // tolerate the endpoint answering with a bare url string
  return typeof data === "string" && data ? [data] : [];
};

export function useGetUserManualLinks(enabled = true): UseQueryResult<string[], Error> {
  return useQuery<string[], Error>(QUERY_KEYS.userManualLinks, getUserManualLinks, {
    enabled: enabled,
    staleTime: Infinity,
    retry: false,
    refetchOnMount: false,
    // The document links are not critical for the app, so failures are logged
    // instead of being pushed to the user as an error toast on every page load.
    onError: (error: any) => {
      console.error("Failed to load user manual links", error);
    },
  });
}
